export default {
  LEAD_SUBMISSION: 'lead_submission',
  ENROLL: 'enroll',
  AWS_PUBLIC_SIGNATURE: 'aws_public_signature',
  SCHOOL_SIGN_UP: 'school_sign_up',
  REGISTRATION_PAYMENT: 'registration_payment'
};
